import MarkdownIt from "markdown-it";
export function markup(markup, adminConfigured) {
    let markupHtml;
    const allowHtml = adminConfigured ? true : false;
    if (markup) {
        markupHtml = MarkdownIt({ html: allowHtml }).render(markup);
    }
    else {
        markupHtml = null;
    }
    return markupHtml;
}
